Auth = require('app/scripts/db/auth')
{ Noun, Verb, track, trackUe, trackDebounced } = require '@trello/analytics'
Util = require 'app/scripts/lib/util'

getFilteredActionsCount = (model) ->
  showDetails = !Auth.isLoggedIn() || Auth.me().getShowDetails()
  filteredActions = model.actionList.filter (action) ->
    if showDetails
      true
    else
      action.isCommentLike()

  return filteredActions.length

module.exports.getFilteredActionsCount = getFilteredActionsCount

module.exports.showDetails = (e) ->
  Util.stop(e)
  Auth.me().setShowDetails(true)
  @getData()
  @renderActionList()

module.exports.hideDetails = (e) ->
  Util.stop(e)
  Auth.me().setShowDetails(false)
  @getData()
  @renderActionList()

module.exports.showAllActions = (e) ->
  @fShowAllActions = true
  @renderShowAllActionsButton()
  @getData()

module.exports.renderShowAllActionsButton = ->
  isMoreToShow = getFilteredActionsCount(@model) >= @defaultActionLimit
  hideButton = @fShowAllActions || !isMoreToShow
  @$('.js-show-all-actions').toggleClass('hide', hideButton)

  @

module.exports.renderActionList = ->
  showDetails = !Auth.isLoggedIn() || Auth.me().getShowDetails()
  @actionListView.setShowDetails(showDetails)
  @waitForId @model, => @actionListView.render()
  @$('.js-show-details').toggleClass('hide', showDetails)
  @$('.js-hide-details').toggleClass('hide', !showDetails)
  return @

module.exports.renderSuggestedActions = ->
  canJoin = @model.isValidSuggestion({ type: 'join' }, true)
  @$('.js-suggested-actions').toggleClass('hide', !canJoin)
  if canJoin
    trackDebounced.hour("Suggestions", "Card Detail", "Displayed", 1)
  @
